import type { IModelListQueryParamsRequest } from '~/services/base/dto/base.dto';

export interface ISemanticCacheRecord {
  id: string;
  category: string;
  questionTh?: string | null;
  questionEn?: string | null;
  answerTh?: string | null;
  answerEn?: string | null;
  route?: string | null;
  inquiryType?: string | null;
  escalationRequired: boolean;
  status: 'pending' | 'queued' | 'approved' | 'failed';
  errorMessage?: string | null;
  cacheHitCount: number;
  pineconeSyncedAt?: string | null;
  updatedAt?: string;
}

export class ModelSemanticCacheRecord implements ISemanticCacheRecord {
  id: string;
  category: string;
  questionTh?: string | null;
  questionEn?: string | null;
  answerTh?: string | null;
  answerEn?: string | null;
  route?: string | null;
  inquiryType?: string | null;
  escalationRequired: boolean;
  status: 'pending' | 'queued' | 'approved' | 'failed';
  errorMessage?: string | null;
  cacheHitCount: number;
  pineconeSyncedAt?: string | null;
  updatedAt?: string;

  constructor(e: any = {}) {
    this.id = e.id;
    this.category = e.category;
    this.questionTh = e.questionTh ?? null;
    this.questionEn = e.questionEn ?? null;
    this.answerTh = e.answerTh ?? null;
    this.answerEn = e.answerEn ?? null;
    this.route = e.route ?? null;
    this.inquiryType = e.inquiryType ?? null;
    this.escalationRequired = !!e.escalationRequired;
    this.status = e.status;
    this.errorMessage = e.errorMessage ?? null;
    this.cacheHitCount = Number(e.cacheHitCount ?? 0);
    this.pineconeSyncedAt = e.pineconeSyncedAt ?? null;
    this.updatedAt = e.updatedAt;
  }
}

export interface ISemanticCacheCategory {
  category: string;
  count: number;
}

export interface ISemanticCacheListParams extends IModelListQueryParamsRequest {
  category?: string;
  status?: string;
  search?: string;
  orderBy?: string;
  orderType?: string;
}

export interface ISemanticCacheTestHit {
  dbId: string;
  score: number;
  standaloneQuestion: string;
  answer: string;
  /** JSON envelope a production cache hit returns; stringified, pretty-printable. */
  productionAnswer: string;
  type: string;
  wouldHit: boolean;
}
